import React from "react";
import "tailwindcss/tailwind.css";

export const Input = ({ label, type, value, onChange, className, required = true, name, id, autoComplete, ...rest }) => {
  const inputId = id || label.toLowerCase().replace(/\s+/g, '-');
  const inputName = name || inputId;
  const inputAutoComplete = autoComplete || inputName;

  return (
    <div className={className}>
      <label
        htmlFor={inputId}
        className="block text-sm font-medium leading-6 text-gray-500 dark:text-gray-400"
      >
        {label}
      </label>
      <div className="mt-1">
        <input
          onChange={onChange}
          id={inputId}
          value={value}
          name={inputName}
          type={type}
          autoComplete={inputAutoComplete}
          required={required}
          {...rest}
          className="px-4 block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary text-sm sm:text-base sm:leading-6"
        />
      </div>
    </div>
  );
};
